export const categories = [
  {
    id: 1,
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Discover the latest sneaker finds, luxury footwear and budget shoe options in our curated spreadsheet.',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20white%20sneakers%20on%20a%20clean%20cream%20colored%20surface%20with%20soft%20natural%20window%20light%20creating%20gentle%20shadows%20editorial%20product%20photography%20minimal%20composition%20warm%20neutral%20tones%20subtle%20texture%20on%20background%20aesthetic%20fashion%20imagery&width=400&height=400&seq=cat-shoes-01&orientation=squarish',
  },
  {
    id: 2,
    name: 'Hoodies / Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Cozy hoodies, premium sweaters and streetwear essentials for every season.',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Plush%20oatmeal%20colored%20hoodie%20neatly%20folded%20on%20a%20warm%20beige%20linen%20background%20soft%20diffused%20daylight%20aesthetic%20flat%20lay%20product%20photography%20minimalist%20style%20clean%20composition%20gentle%20organic%20texture%20fabric%20detail%20visible&width=400&height=400&seq=cat-hoodie-02&orientation=squarish',
  },
  {
    id: 3,
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Graphic tees, designer logos and everyday basics sourced from trusted sellers.',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Crisp%20white%20cotton%20tshirt%20laid%20flat%20on%20a%20light%20sand%20colored%20surface%20with%20soft%20natural%20lighting%20clean%20minimal%20product%20photography%20subtle%20fabric%20wrinkle%20texture%20editorial%20fashion%20style%20neutral%20warm%20tones%20aesthetic%20modern%20composition&width=400&height=400&seq=cat-tshirt-03&orientation=squarish',
  },
  {
    id: 4,
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Bomber jackets, winter coats and lightweight outerwear for your wardrobe.',
    icon: 'ri-t-shirt-air-line',
    image: 'https://readdy.ai/api/search-image?query=Olive%20green%20bomber%20jacket%20hanging%20on%20a%20minimalist%20wooden%20hanger%20against%20a%20warm%20ivory%20wall%20soft%20natural%20side%20lighting%20editorial%20product%20photography%20clean%20aesthetic%20subtle%20texture%20detail%20visible%20on%20fabric%20contemporary%20fashion%20imagery&width=400&height=400&seq=cat-jacket-04&orientation=squarish',
  },
  {
    id: 5,
    name: 'Pants / Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Cargo pants, denim, joggers and summer shorts from top-rated suppliers.',
    icon: 'ri-pantone-line',
    image: 'https://readdy.ai/api/search-image?query=Well%20tailored%20beige%20chino%20pants%20neatly%20folded%20on%20a%20cream%20colored%20linen%20surface%20soft%20natural%20daylight%20balanced%20exposure%20editorial%20product%20photography%20clean%20minimal%20composition%20gentle%20fabric%20texture%20warm%20neutral%20aesthetic&width=400&height=400&seq=cat-pants-05&orientation=squarish',
  },
  {
    id: 6,
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Snapbacks, beanies, bucket hats and caps to complete any outfit.',
    icon: 'ri-contrast-drop-2-line',
    image: 'https://readdy.ai/api/search-image?query=Classic%20black%20baseball%20cap%20placed%20on%20a%20warm%20sand%20colored%20surface%20with%20soft%20natural%20window%20lighting%20clean%20minimal%20product%20photography%20subtle%20shadow%20detail%20editorial%20fashion%20style%20neutral%20background%20aesthetic%20modern%20flat%20lay&width=400&height=400&seq=cat-hat-06&orientation=squarish',
  },
  {
    id: 7,
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Matching tracksuits, coordinated outfit sets and two-piece collections.',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20sweatsuit%20set%20in%20soft%20charcoal%20grey%20neatly%20arranged%20on%20a%20cream%20colored%20linen%20background%20diffused%20natural%20light%20editorial%20product%20photography%20clean%20aesthetic%20minimal%20styling%20gentle%20fabric%20folds%20warm%20neutral%20tones&width=400&height=400&seq=cat-sets-07&orientation=squarish',
  },
  {
    id: 8,
    name: 'Underwear / Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Quality underwear, boxers and essential base layers at affordable prices.',
    icon: 'ri-archive-line',
    image: 'https://readdy.ai/api/search-image?query=Stacked%20premium%20cotton%20boxer%20briefs%20in%20soft%20neutral%20grey%20tones%20on%20a%20warm%20ivory%20surface%20clean%20minimal%20product%20photography%20soft%20natural%20lighting%20editorial%20lifestyle%20aesthetic%20subtle%20fabric%20texture%20gentle%20composition&width=400&height=400&seq=cat-under-08&orientation=squarish',
  },
  {
    id: 9,
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Sports jerseys, football kits and basketball uniforms from reliable vendors.',
    icon: 'ri-basketball-line',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20athletic%20jersey%20in%20deep%20crimson%20red%20laid%20flat%20on%20a%20clean%20cream%20colored%20surface%20soft%20natural%20daylight%20balanced%20exposure%20editorial%20product%20photography%20clean%20composition%20subtle%20fabric%20drape%20sporty%20aesthetic%20warm%20tones&width=400&height=400&seq=cat-jersey-09&orientation=squarish',
  },
  {
    id: 10,
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Watches, jewelry, sunglasses and statement pieces to elevate your style.',
    icon: 'ri-glasses-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20wristwatch%20with%20a%20leather%20strap%20and%20classic%20sunglasses%20resting%20on%20a%20warm%20cream%20colored%20surface%20soft%20directional%20natural%20light%20editorial%20product%20photography%20refined%20aesthetic%20subtle%20reflections%20clean%20composition&width=400&height=400&seq=cat-acc-10&orientation=squarish',
  },
  {
    id: 11,
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Backpacks, crossbody bags, totes and luxury-inspired handbags.',
    icon: 'ri-briefcase-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20crossbody%20bag%20in%20warm%20cognac%20brown%20resting%20on%20a%20cream%20colored%20linen%20surface%20soft%20natural%20window%20lighting%20editorial%20product%20photography%20clean%20minimal%20composition%20subtle%20leather%20grain%20texture%20visible%20elegant%20aesthetic&width=400&height=400&seq=cat-bag-11&orientation=squarish',
  },
  {
    id: 12,
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Designer belts, leather accessories and statement buckles.',
    icon: 'ri-links-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20black%20leather%20belt%20with%20a%20brushed%20metal%20buckle%20coiled%20elegantly%20on%20a%20warm%20cream%20colored%20surface%20soft%20natural%20side%20lighting%20editorial%20product%20photography%20clean%20composition%20subtle%20leather%20texture%20detail%20visible%20refined%20aesthetic&width=400&height=400&seq=cat-belt-12&orientation=squarish',
  },
  {
    id: 13,
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Designer-inspired fragrances, colognes and perfume collections.',
    icon: 'ri-empathize-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20amber%20colored%20fragrance%20on%20a%20cream%20marble%20surface%20soft%20diffused%20natural%20light%20editorial%20product%20photography%20refined%20minimalist%20composition%20subtle%20reflections%20warm%20golden%20tones%20luxurious%20aesthetic&width=400&height=400&seq=cat-perfume-13&orientation=squarish',
  },
  {
    id: 14,
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Gadgets, home goods, electronics and everything else worth discovering.',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20items%20including%20a%20sleek%20bluetooth%20speaker%20a%20minimalist%20notebook%20and%20a%20ceramic%20mug%20arranged%20on%20a%20warm%20cream%20colored%20surface%20soft%20natural%20daylight%20editorial%20product%20photography%20clean%20composition%20warm%20neutral%20tones&width=400&height=400&seq=cat-other-14&orientation=squarish',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';